module.exports = __webpack_public_path__ + "media/images/planning_a_trip_to_japan/zh-hans/1/3-d0369d26b03b54f0fe36e80206fc16c0.jpg";